module.exports = __webpack_public_path__ + "static/img/1071_small.84b2624.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1071_small.png
// module id = vwSK
// module chunks = 1